import { SVGProps } from 'react';

export const BoxTop = (props: SVGProps<SVGSVGElement>) => (
	<svg width="88" height="88" viewBox="0 0 88 88" fill="black" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M88.0004 20.8412C88.0004 20.0585 87.602 19.3267 86.9444 18.9006C86.2867 18.4745 85.4576 18.405 84.7444 18.7246L43.0601 37.2509C42.2218 37.6214 41.6846 38.4505 41.6846 39.3675V85.6833C41.6846 86.4661 42.0783 87.1978 42.7359 87.624C43.3936 88.0501 44.2227 88.1195 44.9406 87.8L86.6248 69.2736C87.4585 68.9031 88.0004 68.0741 88.0004 67.157V20.8412ZM83.3688 24.4029V65.6517L46.3161 82.1216V40.8728L83.3688 24.4029Z"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M3.256 18.7246C2.53811 18.405 1.70905 18.4745 1.05137 18.9006C0.393684 19.3267 0 20.0585 0 20.8412V67.157C0 68.0741 0.537263 68.9031 1.37558 69.2736L43.0598 87.8C43.7731 88.1195 44.6021 88.0501 45.2598 87.624C45.9175 87.1978 46.3158 86.4661 46.3158 85.6833V39.3675C46.3158 38.4505 45.7739 37.6214 44.9402 37.2509L3.256 18.7246ZM4.63158 24.4029L41.6842 40.8728V82.1216L4.63158 65.6517V24.4029Z"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M43.0598 41.4839C43.6573 41.7479 44.3381 41.7479 44.9402 41.4839L86.6244 22.9576C87.4581 22.5871 88 21.758 88 20.8409C88 19.9239 87.4581 19.0948 86.6244 18.7243L44.9402 0.198C44.3381 -0.066 43.6573 -0.066 43.0598 0.198L1.37558 18.7243C0.537263 19.0948 0 19.9239 0 20.8409C0 21.758 0.537263 22.5871 1.37558 22.9576L43.0598 41.4839Z"
		/>
	</svg>
);

export const BoxSide = (props: SVGProps<SVGSVGElement>) => (
	<svg width="88" height="88" viewBox="0 0 88 88" fill="black" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M88.0004 20.8412C88.0004 20.0585 87.602 19.3267 86.9444 18.9006C86.2867 18.4745 85.4576 18.405 84.7444 18.7246L43.0601 37.2509C42.2218 37.6214 41.6846 38.4505 41.6846 39.3675V85.6833C41.6846 86.4661 42.0783 87.1978 42.7359 87.6239C43.3936 88.0501 44.2227 88.1195 44.9406 87.7999L86.6248 69.2736C87.4585 68.9031 88.0004 68.0741 88.0004 67.157V20.8412Z"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M3.256 18.7246C2.53811 18.405 1.70905 18.4745 1.05137 18.9006C0.393684 19.3267 0 20.0585 0 20.8412V67.157C0 68.0741 0.537263 68.9031 1.37558 69.2736L43.0598 87.8C43.7731 88.1195 44.6021 88.0501 45.2598 87.624C45.9175 87.1978 46.3158 86.4661 46.3158 85.6833V39.3675C46.3158 38.4505 45.7739 37.6214 44.9402 37.2509L3.256 18.7246ZM4.63158 24.4029L41.6842 40.8728V82.1216L4.63158 65.6517V24.4029Z"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M43.0598 41.4839C43.6573 41.7479 44.3381 41.7479 44.9402 41.4839L86.6244 22.9576C87.4581 22.587 88 21.758 88 20.8409C88 19.9239 87.4581 19.0948 86.6244 18.7243L44.9402 0.198C44.3381 -0.066 43.6573 -0.066 43.0598 0.198L1.37558 18.7243C0.537263 19.0948 0 19.9239 0 20.8409C0 21.758 0.537263 22.587 1.37558 22.9576L43.0598 41.4839ZM44 36.8338L8.01726 20.8409L44 4.8481L79.9827 20.8409L44 36.8338Z"
		/>
	</svg>
);

export const Box = (props: SVGProps<SVGSVGElement>) => (
	<svg width="89" height="89" viewBox="0 0 89 89" fill="black" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M88.3334 21.1752C88.3334 20.3925 87.9351 19.6607 87.2774 19.2346C86.6197 18.8085 85.7906 18.739 85.0774 19.0586L43.3932 37.5849C42.5548 37.9554 42.0176 38.7845 42.0176 39.7015V86.0173C42.0176 86.8 42.4113 87.5318 43.0689 87.9579C43.7266 88.384 44.5557 88.4535 45.2736 88.1339L86.9578 69.6076C87.7915 69.2371 88.3334 68.408 88.3334 67.491V21.1752ZM83.7018 24.7369V65.9857L46.6492 82.4556V41.2068L83.7018 24.7369Z"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M3.58901 19.0586C2.87111 18.739 2.04206 18.8085 1.38438 19.2346C0.726692 19.6607 0.333008 20.3925 0.333008 21.1752V67.491C0.333008 68.408 0.870271 69.2371 1.70859 69.6076L43.3928 88.1339C44.1061 88.4535 44.9351 88.384 45.5928 87.9579C46.2505 87.5318 46.6488 86.8 46.6488 86.0173V39.7015C46.6488 38.7845 46.1069 37.9554 45.2732 37.5849L3.58901 19.0586Z"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M43.3928 41.8179C43.9903 42.0819 44.6711 42.0819 45.2732 41.8179L86.9574 23.2916C87.7911 22.921 88.333 22.092 88.333 21.1749C88.333 20.2579 87.7911 19.4288 86.9574 19.0583L45.2732 0.531984C44.6711 0.267984 43.9903 0.267984 43.3928 0.531984L1.70859 19.0583C0.870271 19.4288 0.333008 20.2579 0.333008 21.1749C0.333008 22.092 0.870271 22.921 1.70859 23.2916L43.3928 41.8179ZM44.333 37.1678L8.35027 21.1749L44.333 5.18209L80.3157 21.1749L44.333 37.1678Z"
		/>
	</svg>
);
